
import {makeStyles} from '@material-ui/core/styles'
import {colors} from '../../../shared/colors'

const useStyles = makeStyles( theme => ({
    message:{
        fontSize: '2rem',
        fontWeight: 'bold',
        wordBreak: 'break-word',
        textAlign: 'center',
        marginTop: '.5rem',
        marginBottom: '.5rem'
    },
    checkIcon:{
        color: colors.magellanDeepGreen,
        transform: 'scale(3.3)',
    },
    checkIconWrapper: {
        paddingBottom: '1.5rem'
    },
}))

export default useStyles
